










import { Vue, Component, Prop } from "vue-property-decorator";

import PokeTypeBadge from "./PokemonTypeBadge.vue";

@Component({
  name: "poke-type-detail",
  components: {
    PokeTypeBadge
  }
})
export default class PokeTypeDetail extends Vue {
  @Prop()
  title!: string;

  @Prop()
  data!: string[];
}
